import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18 9a9 9 0 0 0-9-9v1.8A7.2 7.2 0 0 1 16.2 9zM0 7.2V2.7a.9.9 0 0 1 .9-.9h4.5a.9.9 0 0 1 .9.9v3.6a.9.9 0 0 1-.9.9H3.6a7.2 7.2 0 0 0 7.2 7.2v-1.8a.9.9 0 0 1 .9-.9h3.6a.9.9 0 0 1 .9.9v4.5a.9.9 0 0 1-.9.9h-4.5C4.836 18 0 13.164 0 7.2" }, null, -1),
    _createElementVNode("path", { d: "M13.989 6.934c.271.655.41 1.357.411 2.066h-1.62A3.78 3.78 0 0 0 9 5.22V3.6a5.4 5.4 0 0 1 4.989 3.334" }, null, -1)
  ]))]))
}
export default { render: render }